import { RowDCF } from 'ComponentLibrary/src/molecules/Table/DCF/TableDCF'
import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import { MonetaryCell, NumberCell } from '../Cells/BaseCells/DisplayCells'
import { Stack } from '@mui/material'
import { CaretDown, CaretUp } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary'
import dayjs from 'dayjs'

const getColumnDefDCF = (data: RowDCF[]) => {
    const columnHelper = createColumnHelper<RowDCF>()
    const columns = [
        columnHelper.accessor('subcategory', {
            header: '',
            id: 'subcategory',
            cell: (info) => {
                const expandable = info.row.getCanExpand()
                const isExpanded = info.row.getIsExpanded()
                return (
                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={tokens.SizingSpacing050}
                        onClick={() => info.row.toggleExpanded()}
                        style={{ cursor: expandable ? 'pointer' : undefined }}
                    >
                        {info.getValue()}
                        {expandable &&
                            (isExpanded ? (
                                <CaretUp size={tokens.SizingIconS} weight="bold" />
                            ) : (
                                <CaretDown size={tokens.SizingIconS} weight="bold" />
                            ))}
                    </Stack>
                )
            },
        }),
    ] as ColumnDef<RowDCF>[]
    data[0].periods.forEach((period, index) => {
        columns.push(
            columnHelper.accessor((row) => row.periods[index]?.value, {
                header: `${dayjs(period.date).year()}`,
                id: period.date,
                cell: (info) => {
                    const value = info.getValue()
                    if (typeof value === 'number') {
                        return <NumberCell number={value} />
                    }
                    return <MonetaryCell monetaryValue={value} />
                },
            }) as ColumnDef<RowDCF>
        )
    })
    columns.push(
        columnHelper.accessor('exitPeriod.value', {
            header: `${dayjs(data[0].exitPeriod.date).year()}`,
            id: data[0].exitPeriod.date,
            cell: (info) => {
                const value = info.getValue()
                if (typeof value === 'number') {
                    return <NumberCell number={value} />
                }
                return <MonetaryCell monetaryValue={value} />
            },
        }) as ColumnDef<RowDCF>
    )
    return columns
}

export { getColumnDefDCF }
